import { stampPanelTemplate } from "./panel-template";

const initNewArrivalsSection = (section) => {
  if (!section || section.dataset.newArrivalsInitialized === "true") return;

  const select = section.querySelector("[data-new-arrivals-select]");
  const cta = section.querySelector("[data-new-arrivals-cta]");
  const panels = Array.from(section.querySelectorAll("[data-new-arrivals-panel]"));

  if (!select || !panels.length) return;

  section.dataset.newArrivalsInitialized = "true";

  const setActivePanel = (value) => {
    panels.forEach((panel) => {
      const isActive = panel.getAttribute("data-new-arrivals-panel") === value;
      if (isActive) {
        // First visit to this collection: stamp its inert <template> into the DOM.
        stampPanelTemplate(panel);
      }
      panel.hidden = !isActive;
    });

    const selectedOption = select.options[select.selectedIndex];
    const selectedCollectionUrl = selectedOption ? selectedOption.dataset.collectionUrl : "";
    if (cta && selectedCollectionUrl) {
      cta.setAttribute("href", selectedCollectionUrl);
    }

    // The section is also a [data-bestsellers-tabs] root: its resize listener
    // (bestsellers-tabs.js) re-runs initScrollerControls, wiring prev/next on
    // any rail that was just stamped in.
    window.dispatchEvent(new Event("resize"));
  };

  select.addEventListener("change", () => {
    setActivePanel(select.value);
  });

  setActivePanel(select.value);
};

const initNewArrivals = (root = document) => {
  if (!root) return;

  if (root.matches && root.matches("[data-new-arrivals-id]")) {
    initNewArrivalsSection(root);
  }

  if (root.querySelectorAll) {
    root.querySelectorAll("[data-new-arrivals-id]").forEach(initNewArrivalsSection);
  }
};

export { initNewArrivals };
